import { CurrencySelect } from "components/molecules/CurrencySelect";
import { FormControl } from "components/molecules/FormControl";
import { NumberInput } from "components/atoms/NumberInput";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { Checkbox } from "components/atoms/Checkbox";
import {
  setInsuranceAmount,
  setInsuranceCurrency,
  setUseInsurance,
  setExtraServiceOptions,
} from "store/createShipmentSlice/index.slice";
import {
  convertValueToDatabase,
  convertDatabaseToValue,
} from "utils/convertGramsToKilos";

export const ExtraServicesFormMain = () => {
  const dispatch = useDispatch();
  const { extraServices } = useSelector((state: RootState) => {
    return state.createShipmentSlice;
  });

  return (
    <div>
      <div className="">
        <div className="mb-4">
          <FormControl label="">
            <Checkbox
              checked={extraServices?.evriHouseHoldSignature}
              onCheckedChange={(checked) => {
                dispatch(
                  setExtraServiceOptions({
                    ...extraServices,
                    evriHouseHoldSignature: checked as boolean,
                    evriSignature: !checked as boolean,
                  })
                );
              }}
              // disabled={!shouldAllowPickUpForm}
            >
              Household Signature
            </Checkbox>
          </FormControl>
        </div>
        <FormControl label="">
          <Checkbox
            checked={extraServices?.evriSignature}
            onCheckedChange={(checked) => {
              dispatch(
                setExtraServiceOptions({
                  ...extraServices,
                  evriHouseHoldSignature: !checked as boolean,
                  evriSignature: checked as boolean,
                })
              );
            }}
          >
            Signature
          </Checkbox>
        </FormControl>
      </div>
    </div>
  );
};
